function ImageViewer({ onCancel }) {
    const styles = {
        overlay: {
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: "10"
        },
        modal: {
            width: "400px",
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "24px",
        },
        header: {
            display: "flex",
            alignItems: "center",
            icon: {
                width: "20px",
                height: "20px",
                color: "#FF0000",
                marginRight: "8px",
            },
            text: {
                color: "#FF0000",
                lineHeight: "1",
                fontWeight: "600",
                fontSize: "18px",
                margin: "0",
            }
        },
        description: {
            fontSize: "14px",
            color: "#71717a",
            margin: "6px 0",
            lineHeight: "20px",

        },
        actions: {
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
            marginTop: "16px",
            button: {
                padding: "8px 16px",
                fontSize: "14px",
                lineHeight: "20px",
                borderRadius: "6px",
                border: "none",
                fontWeight: "500",
                cursor: "pointer",
            },
            deleteBtn: {
                backgroundColor: "#FF0000",
                color: "white",
            }
        }
    };
    return (
        <div style={styles.overlay} onClick={onCancel}>
            {/* <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                  <div style={styles.header}>
                      <LuTriangleAlert style={styles.header.icon} />
                      <h2 style={styles.header.text}>Confirm Deletion</h2>
                  </div>
                  <p style={styles.description}>Are you sure you want to delete this image? This action cannot be undone.</p>
                  <div style={styles.actions}>
                      <button onClick={onCancel} style={styles.actions.button}>Cancel</button>
                      <button style={{ ...styles.actions.button, ...styles.actions.deleteBtn }}>Delete Image</button>
                  </div>
            //   </div> */}
            <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                
            </div>
        </div>
    )
}

export default ImageViewer;